export const asyncAwareButtonId = {
  submit: 'asyncAwareButtonId-submit',
};
